import { ChangeDetectionStrategy, Component } from "@angular/core";
import { OfferCardDirective } from "./offer-card";

@Component({
    selector: "deloitteai-offercard-buyer",
    templateUrl: "./offer-card.buyer.html",
    styleUrls: ["./offer-card.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeloitteAiOfferCardBuyerComponent extends OfferCardDirective {
}
